import React, { useState } from 'react'

export const Tab = ({children,title,isOpen = false}) => {
    const [open,setOpen] = useState(isOpen)

  return (
    <div className='tab'>
        <div className='tab-title' onClick={()=>setOpen(prevState=>!prevState)}>
            {title}
            <i className={`fas fa-angle-${open?'up':'down'}`}/>
        </div>
        <div className={`tab-body ${open ? 'active': ''}`}>
            {children}
        </div>
        
    </div>
  )
}
